import {
    ViewListingConciergeWrapper,
    ViewListingConciergeContent,
    ViewListingConciergeTitle,
    ViewListingConciergeText,
    ViewListingConciergeInputWrapper,
    ViewListingConciergeInput,
    ViewListingConciergeSendButton,
    ViewListingConciergeExamples,
    ViewListingConciergeExampleButton
} from "../viewListingStyling";
import { useState } from "react";
import styled from "styled-components";

const MobileConciergeExamples = styled(ViewListingConciergeExamples)`
    @media (max-width: 767px) {
        max-height: 76px;
        overflow: hidden;
    }
`;

interface ViewListingConciergeProps {
    toggleSendMessageRequest: () => void;
}

const EXAMPLES = [
    "Can you help me book an airport transfer?",
    "What local experiences do you recommend?",
    "Can I arrange a late checkout?",
    "Can you help with restaurant reservations?"
];

export default function ViewListingConcierge({ toggleSendMessageRequest }: ViewListingConciergeProps) {
    const [inputValue, setInputValue] = useState("");

    const handleSend = () => {
        if (inputValue.trim()) {
            if (typeof window !== 'undefined' && (window as any).Intercom) {
                (window as any).Intercom('showNewMessage', inputValue);
            }
            setInputValue("");
        }
    };

    return (
        <ViewListingConciergeWrapper hidden={true}>
            <ViewListingConciergeContent>
                <ViewListingConciergeTitle>Ask concierge</ViewListingConciergeTitle>
                <ViewListingConciergeText>Message our 24/7 concierge team.</ViewListingConciergeText>
                <ViewListingConciergeInputWrapper>
                    <ViewListingConciergeInput
                        placeholder="Type your message..."
                        value={inputValue}
                        onChange={e => setInputValue(e.target.value)}
                    />
                    {inputValue.trim() && (
                        <ViewListingConciergeSendButton type="button" onClick={handleSend}>
                            Send
                        </ViewListingConciergeSendButton>
                    )}
                </ViewListingConciergeInputWrapper>
                <MobileConciergeExamples>
                    {EXAMPLES.map((example, idx) => (
                        <ViewListingConciergeExampleButton
                            key={idx}
                            type="button"
                            onClick={() => setInputValue(example)}
                        >
                            {example}
                        </ViewListingConciergeExampleButton>
                    ))}
                </MobileConciergeExamples>
            </ViewListingConciergeContent>
        </ViewListingConciergeWrapper>
    );
} 